module.exports = __webpack_public_path__ + "img/取消购买完.0417dc41.svg";